import { NgModule } from "@angular/core";
import { CardModule } from "primeng/card";
import { SharedModule } from "../shared/shared.module";
import { AcessoBloqueadoComponent } from "./components/acesso-bloqueado/acesso-bloqueado.component";
import { LoginComponent } from "./components/login/login.component";
import { NaoAutorizadoComponent } from "./components/nao-autorizado/nao-autorizado.component";
import { SecutiryRoutingModule } from "./security-routing.module";

@NgModule({
  imports: [SharedModule, SecutiryRoutingModule, CardModule],
  declarations: [
    LoginComponent,
    NaoAutorizadoComponent,
    AcessoBloqueadoComponent,
  ],
})
export class SecurityModule {}
